import { BooleanColumn, NumericalColumn, StringColumn } from 'baseui/data-table';

export const COL_NAMES = {
	versionCode: 'versionCode',
	isForceUpdate: 'isForceUpdate',
	apkUrlArmV8: 'apkUrlArmV8',
	apkUrlArmV7: 'apkUrlArmV7',
	gameName: 'gameName'
};

export const columnConfigs = [
	StringColumn({
		title: 'Game Name',
		mapDataToValue: (data: any) => data[COL_NAMES.gameName]
	}),
	NumericalColumn({
		title: 'Version Number',
		mapDataToValue: (data: any) => data[COL_NAMES.versionCode]
	}),
	StringColumn({
		title: 'Sub App Apk Url V8',
		mapDataToValue: (data: any) => data[COL_NAMES.apkUrlArmV8]
	}),
	BooleanColumn({
		title: 'Is Force Update',
		mapDataToValue: (data: any) => data[COL_NAMES.isForceUpdate]
	})
];
